import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormArray } from '@angular/forms';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';

import {
  BeneficiaryCardEnum,
  EntityEnum,
  IContractByNumberFormData,
  IContractInput
} from 'src/app/models/contract';
import {
  IBeneficiaryFormGroup,
  IGenericContract
} from 'src/app/models/generic';
import { ITab } from 'src/app/models/tabs';
import { ApiContractService } from 'src/app/services/api/api-contract.service';
import { Inputs } from '../../utils/base';
import { IGenericContractFormGroup } from '../../../models/generic';

@Component({
  selector: 'app-modal-contract-visualize',
  templateUrl: './modal-contract-visualize.component.html',
  styleUrls: ['./modal-contract-visualize.component.scss']
})
export class ModalContractVisualizeComponent implements OnInit {
  _form!: FormGroup<IGenericContractFormGroup>;
  BeneficiaryCardEnum = BeneficiaryCardEnum;
  contractData!: IGenericContract;
  EntityEnum = EntityEnum;
  tabs: ITab[] = [];

  editableFields: { [key: string]: string[] } = {
    Contract: [],
    Beneficiary: []
  };

  inputControlsDetails: IContractInput[] = Inputs[
    'detalhes'
  ] as IContractInput[];
  inputControlsFinancy: IContractInput[] = Inputs[
    'financiamento'
  ] as IContractInput[];
  invoiceBeneficiariesControls = Inputs[
    'beneficiarioParceiro'
  ] as IContractInput[];
  transferBeneficiariesControls = Inputs[
    'beneficiarioSubsidiaria'
  ] as IContractInput[];

  constructor(
    private _dialogRef: MatDialogRef<ModalContractVisualizeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IContractByNumberFormData,
    private _contractService: ApiContractService
  ) { }

  ngOnInit(): void {
    this.initalizeForm();
  }

  initalizeForm(): void {
    this._contractService.initializeForm(
      this.data.Contract!.Number,
      this.data.Contract!.QueryNumber,
      this.data.Contract!.FinancialInstitution).subscribe({
        next: (response) => {
          this._form = response;
          this.contractData = this._contractService.contractData;
        },
        error: (err) => this.handleFormError()
      });
  }

  handleFormError(): void {
    this._dialogRef.close();
  }

  get Beneficiaries() {
    return this._form.controls['Beneficiaries'] as FormArray<
      FormGroup<IBeneficiaryFormGroup>
    >;
  }

  close(action: boolean): void {
    let data = null;
    this._dialogRef.close(data);
  }
}
